import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./app/App";
import AppProviders from "./app/AppProviders";
import ErrorBoundary from "./components/ErrorBoundary";

import "./App.css";

// Apply OS-preference theme before React renders to avoid a light/dark flash
// (FOUC). This is only a placeholder — the real theme comes from the user's
// settings API response and is applied by Header.jsx once it loads.
(() => {
  const prefersDark = window.matchMedia?.("(prefers-color-scheme: dark)").matches;
  document.documentElement.classList.toggle("dark", prefersDark);
})();

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(

  <ErrorBoundary>

    <BrowserRouter>

      <AppProviders>

        <App />

      </AppProviders>

    </BrowserRouter>

  </ErrorBoundary>

);
